const getLeadScore = ({ leadInfos }) => parseFloat(leadInfos.score);

export { getLeadScore };
